import { format } from 'fecha';


module.exports = {
  Actions: {
    pop() {
      window.mmtHistory.goBack()
    },
    railsPasswordReminder(params) {
      if (params && params.type === 'replace') {
        window.mmtHistory.replace('/railways/search/railsPasswordReminder', params);
      } else {
        window.mmtHistory.push('/railways/search/railsPasswordReminder', params);
      }
    },
    railsReviewPage(params) {
      if (params && params.type === 'replace') {
        window.mmtHistory.replace('/railways/search/railsReviewPage', params);
      } else {
        window.mmtHistory.push('/railways/search/railsReviewPage', params);
      }
    },
    railsCreateAccountPage(params) {
      if (params.type === 'replace') {
        window.mmtHistory.replace('/railways/search/railsCreateAccountPage', params);
      } else {
        window.mmtHistory.push('/railways/search/railsCreateAccountPage', params);
      }
    },
    railsOtpVerification(params) {
      if (params.type === 'replace') {
        window.mmtHistory.replace('/railways/search/railsOtpVerification', params);
      } else {
        window.mmtHistory.push('/railways/search/railsOtpVerification', params);
      }
    },
    railsForgotUsername(params) {
      if (params.type === 'replace') {
        window.mmtHistory.replace('/railways/search/railsForgotUsername', params);
      } else {
        window.mmtHistory.push('/railways/search/railsForgotUsername', params);
      }
    },
    railsForgotPassword(params) {
      if (params.type === 'replace') {
        window.mmtHistory.replace('/railways/search/forgotPassword', params);
      } else {
        window.mmtHistory.push('/railways/search/forgotPassword', params);
      }
    },
    railsForgotIrctcPassword(params) {
      if (params.type === 'replace') {
        window.mmtHistory.replace('/railways/search/forgotIrctcPassword', params);
      } else {
        window.mmtHistory.push('/railways/search/forgotIrctcPassword', params);
      }
    },
    railsNeedHelp(params) {
      if (params.type === 'replace') {
        window.mmtHistory.replace(`/railways/search/needHelp?mmtId=${params?.mmtId}`, params);
      } else {
        window.mmtHistory.push(`/railways/search/needHelp?mmtId=${params?.mmtId}`, params);
      }
    },
    railsCreateAccountSuccess(params) {
      if (params.type === 'replace') {
        window.mmtHistory.replace('/railways/search/railsCreateAccountSuccessPage', params);
      } else {
        window.mmtHistory.push('/railways/search/railsCreateAccountSuccessPage', params);
      }
    },
    rails() {
      window.mmtHistory.push('/railways/search');
    },
    railsCityPicker(params) {
      window.mmtHistory.push('/railways/search/railsCityPicker', params)
    },
    railsCalendar(params) {
      window.mmtHistory.push('/railways/search/railsCalendar', params)
    },
    railsListing(params) {
      const {
        originStation: from,
        destinationStation: to,
        departureDate
      } = params;
      const dateStr = format(departureDate, 'YYYYMMDD');
      const query = `from_city=${from.cityName}&from=${from.code}&from_station=${from.stationName}&to_city=${to.cityName}&to=${to.code}&to_station=${to.stationName}&departure=${dateStr}`
      window.mmtHistory.push(`/railways/search/railsListingPage?${query}`)
    },
     railsListingNew(params) {
      window.mmtHistory.push(`/railways/listing${params}`)
    },
    railsFilters(params) {
      window.mmtHistory.push('/railways/search/railsListingPage/filters', params)
    },
    railsAlternateListing(params) {
      window.mmtHistory.push('/railways/search/railsListingPage/alternate', params)
    },
    connectedTravelPage(params) {
      window.mmtHistory.push('/railways/search/railsListingPage/connected-travel', params);
    },
    railsRefund(params) {
      window.mmtHistory.push('/railways/search/railsRetryBooking/railsRefund', params);
    },
    travelers(params) {
      const {
        originStation: from,
        destinationStation: to,
        departureDate,
        trainNumber,
        classCode,
        quota,
        ...rest
      } = params;
      const dateStr = format(departureDate, 'YYYYMMDD');
      const query = `from_city=${from.cityName}&from=${from.code}&to_city=${to.cityName}&to=${to.code}&departure=${dateStr}&trainNumber=${trainNumber}&classCode=${classCode}&quota=${quota}&randID=${Date.now()}`
      window.mmtHistory.push(`/railways/search/railsTravelerPage?${query}`, params);
    },
    tgsTravellersPage(params) {
      const {pnrNumber} = params;
      window.mmtHistory.push(`/railways/pnrsearch/TGS/traveller?pnrNumber=${pnrNumber}`)
    }
    ,
    addTraveler(params) {
      window.mmtHistory.push(`/railways/search/railsTravelerPage/addTraveller`, params);
    },
    trainsBookingPolicy(params) {
      window.mmtHistory.push(`/railways/search/trainsBookingPolicy`, params);
    },
    openIrctcPage() {
      window.mmtHistory.push('/railways/search/openIrctcPage');
    },
    openWebView(params) {
      window.mmtHistory.push('/railways/search/webView', params);
    },
    railsBusCommonLanding(params) {
      window.mmtHistory.push('/railways', params);
    },
    railNewLanding(params) {
      window.mmtHistory.push('/railways', params);
    },
    railsPNRStatusLanding(params) {
      window.mmtHistory.push('/railways/PNR', params);
    },
    pnrStatusPage(params) {
      const {pnr} = params;
      window.mmtHistory.push(`/railways/pnrsearch?pnr=${pnr}`, params);
    },
    coachPosition(params) {
      window.mmtHistory.push('/railways/coach-position', params);
    },
    coachPositionList(params) {
      window.mmtHistory.push('/railways/coach-position-details', params);
    },
    tgsLandingPage(params) {
      window.mmtHistory.push('/railways/TGS/landing', params);
    },
    railsPWA(params) {
      window.mmtHistory.push('/pwa/railsPwa', params);
    },
    railsTrainNumberPicker(params) {
      window.mmtHistory.push('/railways/trainNumber', params);
    },
    railsStationPicker(params) {
      window.mmtHistory.push('/railways/stationPicker', params);
    },
    railsDatePicker(params) {
      window.mmtHistory.push('/railways/datePicker', params);
    },
    railLiveStationLanding(params) {
      window.mmtHistory.push('/railways/live-station', params);
    },
    liveStationList(params) {
      window.mmtHistory.push('/railways/live-station-details', params);
    },
    railLiveTrainStatusLanding(params) {
      window.mmtHistory.push('/railways/liveStatus', params);
    },
    railLiveTrainStatusRNLanding(params) {
      window.mmtHistory.push('/railways/live-trains', params);
    },
    trainScheduleCheck(params) {
      window.mmtHistory.push('/railways/schedule', params);
    },
    railsTrainSchedule(params) {
      window.mmtHistory.push('/railways/scheduleDetail', params);
    },
    bookBreakJourney(params) {
      window.mmtHistory.push('/railways/search/bookBreakJourney', params)
    },
    webViewForError(params) {
      window.mmtHistory.push('/railways/search/webViewForError', params)
    },
    openCreateIRCTCAccountWebView(params) {
      window.mmtHistory.push('/railways/search/createIRCTCAccount', params)
    },
  },
  ActionConst: {}
}
